import React, { useState, useEffect, useRef } from 'react';
import './Tooltip.css';

const Tooltip = ({ 
  children, 
  content, 
  position = 'top', 
  delay = 150,
  verticalOffset = 9,
  triggerClassName = ''
}) => {
  const [visible, setVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef(null);
  const triggerRef = useRef(null);

  const updatePosition = () => {
    if (triggerRef.current && tooltipRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      
      let top, left;
      
      left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2);
      
      switch (position) {
        case 'top':
          top = triggerRect.top - tooltipRect.height - verticalOffset;
          break;
        case 'bottom':
          top = triggerRect.bottom + verticalOffset;
          break;
        case 'left':
          left = triggerRect.left - tooltipRect.width - verticalOffset;
          top = triggerRect.top + (triggerRect.height / 2) - (tooltipRect.height / 2);
          break;
        case 'right':
          left = triggerRect.right + verticalOffset;
          top = triggerRect.top + (triggerRect.height / 2) - (tooltipRect.height / 2);
          break;
        default:
          top = triggerRect.top - tooltipRect.height - verticalOffset;
      }

      left = Math.max(5, Math.min(left, window.innerWidth - tooltipRect.width - 5));
      top = Math.max(5, Math.min(top, window.innerHeight - tooltipRect.height - 5));

      setCoords({ top, left });
    }
  };

  const showTooltip = () => {
    const id = setTimeout(() => {
      setVisible(true);
      setTimeout(updatePosition, 10);
    }, delay);
    setTimeoutId(id);
  };

  const hideTooltip = () => {
    clearTimeout(timeoutId);
    setVisible(false);
  };

  useEffect(() => {
    if (visible) {
      updatePosition();
      window.addEventListener('scroll', hideTooltip);
      return () => window.removeEventListener('scroll', hideTooltip);
    }
  }, [visible]);

  return (
    <div 
      className={`tooltip-wrapper ${triggerClassName}`} 
      ref={triggerRef}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      {children}
      {visible && (
        <div 
          className={`tooltip-box tooltip-${position}`}
          ref={tooltipRef}
          style={{ position: 'fixed', top: `${coords.top}px`, left: `${coords.left}px`, zIndex: 9999 }}
        >
          {content}
          <div className={`tooltip-arrow tooltip-arrow-${position}`} />
        </div>
      )}
    </div>
  );
};

export default Tooltip;


